import { Injectable } from '@angular/core';
import { TypeChangementEnum } from '../../constantes/type-changement.enum';
import { CybermetrieService, Evenement } from '@oel/js-cybermetrie';
import { CybermetrieEnum } from '../../models/cybermetrie/cybermetrie.enum';

@Injectable({
  providedIn: 'root',
})
export class CybermetrieCoordonneesService {
  constructor() {}

  envoyerEvenementPersonnalise(
    eventCategory: string,
    eventAction: string,
    eventLabel: string,
    value?: number,
    type?: string,
    champExtra?: Map<string, string>
  ): void {
    if (eventCategory !== null && eventAction !== null && eventLabel !== null) {
      let typeModification = '';
      if (type) {
        switch (type) {
          case TypeChangementEnum.COORDONNEES:
            typeModification = 'adresse principale';
            break;
          case TypeChangementEnum.COURRIEL:
            typeModification = 'courriel';
            break;
          case TypeChangementEnum.TELEPHONE:
            typeModification = 'telephone';
            break;
          default:
            typeModification = 'adresse principale|telephone|courriel';
        }
      }

      let valeur = 0;
      if (value) {
        valeur = value;
      }
      this.envoyerCybermetrieEvenement(eventCategory, eventAction, eventLabel + typeModification, valeur, champExtra);
    }
  }

  envoyerEvenementPersonnaliseBancaire(
    eventCategory: string,
    eventAction: string,
    eventLabel: string,
    champExtra?: Map<string, string>
  ): void {
    if (eventCategory !== null && eventAction !== null && eventLabel !== null) {
      this.envoyerCybermetrieEvenement(eventCategory, eventAction, eventLabel, 0, champExtra);
    }
  }

  private envoyerCybermetrieEvenement(
    eventCategory: string,
    eventAction: string,
    eventLabel: string,
    valeur: number,
    champExtra?: Map<string, string>
  ): void {
    CybermetrieService.envoyerEvenement(
      {
        event: Evenement.InterractionsPages,
        category: eventCategory,
        action: eventAction,
        label: eventLabel,
        value: valeur,
        nonInteraction: false,
      },
      champExtra
    );
  }

  clickModifierCoordonneesBancaire(champExptra: string): void {
    const extraAttribut = new Map<string, string>([[CybermetrieEnum.EXTRA_ATTRIBUT, champExptra]]);
    this.envoyerEvenementPersonnaliseBancaire(
      CybermetrieEnum.CATEGORIE_GESTION_BANCAIRE,
      CybermetrieEnum.ACTION_CLIC,
      CybermetrieEnum.LABEL_BANCAIRE_MODIFIER,
      extraAttribut
    );
  }

  clickModifierCoordonneesBancaireErreur(label: string, champExptra: string): void {
    const messageErreur = new Map<string, string>([[CybermetrieEnum.MESSAGE_ERREUR, champExptra]]);
    this.envoyerEvenementPersonnaliseBancaire(
      CybermetrieEnum.CATEGORIE_GESTION_BANCAIRE,
      CybermetrieEnum.ACTION_CLIC,
      label,
      messageErreur
    );
  }

  clickCoordonneesBancaire(label: string): void {
    this.envoyerEvenementPersonnaliseBancaire(
      CybermetrieEnum.CATEGORIE_GESTION_BANCAIRE,
      CybermetrieEnum.ACTION_CLIC,
      label
    );
  }

  clickModifierCoordonneesAutresProduits(champExptra: string): void {
    const extraAttribut = new Map<string, string>([[CybermetrieEnum.EXTRA_ATTRIBUT, champExptra]]);
    this.envoyerEvenementPersonnaliseBancaire(
      CybermetrieEnum.CATEGORIE_GESTION_BANCAIRE,
      CybermetrieEnum.ACTION_CLIC,
      CybermetrieEnum.LABEL_BANCAIRE_AUTRES_PRODUITS,
      extraAttribut
    );
  }

  clickAnnulerCoordonneesBancaire(champExptra: string): void {
    const extraAttribut = new Map<string, string>([[CybermetrieEnum.EXTRA_ATTRIBUT, champExptra]]);
    this.envoyerEvenementPersonnaliseBancaire(
      CybermetrieEnum.CATEGORIE_TRANSACTION,
      CybermetrieEnum.ACTION_ANNULER,
      CybermetrieEnum.LABEL_BANCAIRE_TRX,
      extraAttribut
    );
  }

  entrerTransactionCoordonneesBancaire(nombreComptes: number): void {
    switch (nombreComptes) {
      case 0:
        this.transactionCoordonneesBancaire(CybermetrieEnum.ACTION_EOF);
        break;
      case 1: {
        const extraAttribut = new Map<string, string>([[CybermetrieEnum.EXTRA_ATTRIBUT, CybermetrieEnum.UN_COMPTE]]);
        this.envoyerEvenementPersonnaliseBancaire(
          CybermetrieEnum.CATEGORIE_TRANSACTION,
          CybermetrieEnum.ACTION_ENTREE,
          CybermetrieEnum.LABEL_BANCAIRE_TRX,
          extraAttribut
        );
        break;
      }
      default: {
        const extra = new Map<string, string>([[CybermetrieEnum.EXTRA_ATTRIBUT, CybermetrieEnum.PLUSIEURS_COMPTE]]);
        this.envoyerEvenementPersonnaliseBancaire(
          CybermetrieEnum.CATEGORIE_TRANSACTION,
          CybermetrieEnum.ACTION_ENTREE,
          CybermetrieEnum.LABEL_BANCAIRE_TRX,
          extra
        );
        break;
      }
    }
  }

  debuterTransactionCoordonneesBancaire(): void {
    // timeout pour s'assurer que l'événement est bien capté après le chargement de la page.
    // Sans le timeout on a extraAtribut indésirable
    setTimeout(() => {
      this.envoyerEvenementPersonnaliseBancaire(
        CybermetrieEnum.CATEGORIE_TRANSACTION,
        CybermetrieEnum.ACTION_DEBUTE,
        CybermetrieEnum.LABEL_BANCAIRE_TRX
      );
    }, 500);
  }

  transactionCoordonneesBancaire(action: string): void {
    this.envoyerEvenementPersonnaliseBancaire(
      CybermetrieEnum.CATEGORIE_TRANSACTION,
      action,
      CybermetrieEnum.LABEL_BANCAIRE_TRX
    );
  }

  interactionRadioBoutonCoordonneesBancaire(valueRadioBouton: boolean): void {
    const value = valueRadioBouton ? 'oui' : 'non';
    const extraAttribut = new Map<string, string>([[CybermetrieEnum.EXTRA_ATTRIBUT, value]]);
    this.envoyerEvenementPersonnaliseBancaire(
      CybermetrieEnum.CATEGORY_INTERACTIONS_FORMES,
      CybermetrieEnum.ACTION_RADIO_BOUTON,
      CybermetrieEnum.LABEL_BANCAIRE,
      extraAttribut
    );
  }

  transactionErreurTechnique(texteErreurs: string[], isBancaire: boolean): void {
    const separator = isBancaire ? ' | ' : '|';
    const erreurs = new Map<string, string>();
    erreurs.set(CybermetrieEnum.MESSAGE_ERREUR, texteErreurs.join(separator));
    const label = isBancaire ? CybermetrieEnum.LABEL_BANCAIRE_TRX : CybermetrieEnum.LABEL_INFOS_TOTAL;
    this.envoyerEvenementPersonnalise(
      CybermetrieEnum.CATEGORIE_TRANSACTION,
      CybermetrieEnum.ACTION_ERREUR_TECHNIQUE,
      label,
      null,
      null,
      erreurs
    );
  }
}
